export default "__VITE_ASSET__BmLn22JC__"